import React from 'react';
import { useDivisionCheck } from 'src/hooks/useDivisionCheck';

interface DivisionCheckProviderProps {
  children: React.ReactNode;
}

/**
 * Provider that runs v2Validate on mount and tab focus for all apps.
 *
 * - On mount: captures the initial division and syncs localStorage.
 * - On tab focus: detects auth expiry (redirects to sign-in) and
 *   refreshes if user logged in from another tab.
 *
 * Division mismatch UI (ring + popup) is handled by each app's header:
 * AccountDivisionPopover for Atlas/Beacon, OmniNavAccountLink for Omni.
 */
const DivisionCheckProvider: React.FC<DivisionCheckProviderProps> = ({ children }) => {
  useDivisionCheck();
  return <>{children}</>;
};

export default DivisionCheckProvider;
